import {Store} from "pullstate";
import _ from "../../src/_/index";
import {AuthStore, saveOfflineAuth} from "./Common_Store";

// 8_6: 訪客填表建立帳號 (廠商發出的邀請連結，匿名存取)
export const Pg_8_6_Store = new Store({});

let fetchOption = (postParams: any) => {
    return {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(postParams)
    } as any;
};

// 後端回傳不是 JSON (例如 404 頁) 時給一個可顯示的錯誤，不要讓頁面炸掉
const readJson = async (response: Response) => {
    try {
        return await response.json();
    } catch (e) {
        return {error: {code: -1, message: '伺服器回應異常，請稍後再試'}};
    }
};

export type Item_委託建立會員 = {
    TicketCode: string,
    手機_Masked: string,
    暱稱: string,
    Email: string,
    IsTicketCodeUsed: boolean,
    CreatedAt: string,
    TicketExpireAt: string,
    委託者暱稱: string,
    Gift: { TokenId: string, 名稱: string } | null,
};

// 讀取邀請單。成功回傳 Item_委託建立會員；失敗回傳 {error} (不 alert，由頁面顯示)
export const fetch_pg_8_6 = async (postParams: { ticketcode: string }): Promise<{ item?: Item_委託建立會員, error?: any }> => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_8_6`, fetchOption(postParams));
    const data = await readJson(response);

    const error = data.error || null;
    if (error == null) {
        const payload = data.payload;
        _._d.warn(payload);
        Pg_8_6_Store.update(s => {
            return Object.assign(s, payload);
        });
        return {item: payload?.Root?.Item_委託建立會員};
    }
    return {error};
};

export type Pg_8_6_CreateResult = {
    AuthData: any,
    SessionId: string,
    Gift_TokenEnwId: string | null,
    Gift: { TokenId: string, 名稱: string } | null,
    Message: string,
    NextAction: string,
};

// 建立帳號。成功時視同登入 (與 _pg_A_1/login 相同的 AuthStore 處理)；失敗回傳 {error}
export const push_pg_8_6 = async (postParams: {
    ticketcode: string,
    create_nickname: string,
    create_email: string,
    create_password: string,
}): Promise<{ result?: Pg_8_6_CreateResult, error?: any }> => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_6`, fetchOption(postParams));
    const data = await readJson(response);

    const error = data.error || null;
    if (error == null) {
        const payload: Pg_8_6_CreateResult = data.payload;
        _._d.warn(payload);

        AuthStore.update(s => {
            let _s: any = s;
            Object.assign(_s, {AuthData: payload.AuthData, SessionId: payload.SessionId});
            Object.assign(_s, {signBy: 'push_pg_8_6'});
            return _s;
        });
        await saveOfflineAuth();

        return {result: payload};
    }
    return {error};
};
